/**
 * Offer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Balloon } from './balloon';


export interface Loan { 
    purpose?: Loan.PurposeEnum;
    amount?: number;
    duration?: string;
    balloon?: Balloon;
    initPurpose?: string;
    customerLoanAmount?: number;
}
export namespace Loan {
    export type PurposeEnum = 'NEW_CAR' | 'USED_CAR' | 'MOTORBIKE' | 'DEBT_CONVERSION' | 'DISPO' | 'FURNITURE' | 'MODERNIZATION' | 'JOURNEY' | 'ELECTRONICS' | 'BALLON' | 'OTHER';
    export const PurposeEnum = {
        NewCar: 'NEW_CAR' as PurposeEnum,
        UsedCar: 'USED_CAR' as PurposeEnum,
        Motorbike: 'MOTORBIKE' as PurposeEnum,
        DebtConversion: 'DEBT_CONVERSION' as PurposeEnum,
        Dispo: 'DISPO' as PurposeEnum,
        Furniture: 'FURNITURE' as PurposeEnum,
        Modernization: 'MODERNIZATION' as PurposeEnum,
        Journey: 'JOURNEY' as PurposeEnum,
        Electronics: 'ELECTRONICS' as PurposeEnum,
        Ballon: 'BALLON' as PurposeEnum,
        Other: 'OTHER' as PurposeEnum
    };
}


